
/**
 * Cart page reorder — moves the "Wrapin - Gift Wrap" app block into the
 * LEFT column of the cart footer, always — whether or not the native cart
 * note ("Order special instructions") field is active. When the cart note
 * is active, it's placed directly below the Wrapin block, in the same spot.
 *
 * Why this needs code: the Wrapin block is a reorderable app block in the
 * Shopify theme editor, but it lives in the right-hand column of the cart
 * footer (with the totals/checkout button), while the cart note field is
 * hardcoded into the left column and isn't a block at all — so there's no
 * drag-and-drop path between them in the customizer, and no customizer
 * option to pin the block to the left column on its own.
 *
 * Built for the Dawn theme's cart page markup:
 *   .cart__footer                 (flex row on desktop: left | right)
 *     cart-note.cart__note.field  (when active — <label> + <textarea>)
 *     .cart__blocks               (right column: totals, app blocks,
 *                                  checkout button)
 *       [id*="wrapin"]            (the Wrapin app block, somewhere inside)
 *
 * IMPORTANT: <cart-note> is itself a flex container with an absolutely
 * positioned floating <label> — it's built to hold exactly one flex child
 * (the textarea). Inserting the Wrapin block directly inside it turns the
 * textarea into a second flex item (pushing them side by side) while the
 * label keeps floating at its original fixed offset, landing on top of
 * the Wrapin block instead of above the textarea. So instead of reaching
 * inside <cart-note>, this script creates a new plain wrapper div, always
 * puts it first in .cart__footer (the left-column slot), and puts the
 * Wrapin block inside it — with <cart-note> joining underneath only when
 * it exists. <cart-note>'s own internal layout is never touched.
 *
 * This also naturally fixes the right column's width: Dawn has a rule
 * that pushes .cart__blocks to the right with an auto left-margin only
 * when it's the *only* child of .cart__footer (i.e. when the cart note is
 * off). Since our wrapper is always present as a sibling, .cart__blocks is
 * never the only child, so it keeps its normal (non-stretched) layout in
 * both states.
 *
 * INSTALL:
 * 1. Shopify admin → Online Store → Themes → your theme → "..." → Edit code
 * 2. In the Assets folder, open (or create) cart-wrapin-reorder.js →
 *    paste this whole file (replacing any previous version) → Save
 * 3. Open layout/theme.liquid, find the closing </body> tag near the bottom,
 *    and add this line just above it (a second <script> line is fine if
 *    you already added one there for a different file):
 *      <script src="{{ 'cart-wrapin-reorder.js' | asset_url }}" defer="defer"></script>
 * 4. Save theme.liquid, then preview the cart page with an item in it.
 */
(function () {
  var STYLE_ID = 'cart-wrapin-reorder-styles';
  var STACK_ID = 'wrapin-note-stack';
 
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + STACK_ID + ' {',
      '  display: block;',
      '}',
      '#' + STACK_ID + ' > * + * {',
      '  margin-top: 16px;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }
 
  function moveWrapinBlock() {
    var footer = document.querySelector('.cart__footer');
    if (!footer) return;
 
    var wrapinBlock = document.querySelector('.cart__blocks [id*="wrapin" i]');
    var cartNote = document.querySelector('cart-note');
    var stack = document.getElementById(STACK_ID);
 
    if (!stack) {
      // Nothing to build the left column around yet.
      if (!wrapinBlock) return;
 
      stack = document.createElement('div');
      stack.id = STACK_ID;
 
      // Always the first (left-column) child of the footer, regardless of
      // whether the cart note is active.
      footer.insertBefore(stack, footer.firstChild);
      stack.appendChild(wrapinBlock);
      if (cartNote) stack.appendChild(cartNote);
      return;
    }
 
    // Stack already exists (e.g. a quantity change re-rendered part of the
    // footer without destroying our wrapper) — make sure both pieces are
    // still inside it, in case either got put back in its original spot.
    if (wrapinBlock && wrapinBlock.parentElement !== stack) {
      stack.appendChild(wrapinBlock);
    }
    if (cartNote && cartNote.parentElement !== stack) {
      stack.appendChild(cartNote);
    }
  }
 
  function init() {
    injectStyles();
    moveWrapinBlock();
  }
 
  document.addEventListener('DOMContentLoaded', init);
  // The cart footer (or the whole cart section) can be re-rendered
  // wholesale — quantities changing, a discount code being applied, or a
  // theme-editor setting toggling the cart note on/off — which swaps in
  // fresh server HTML and would put things back in their original spots.
  // Re-apply whenever that happens.
  document.addEventListener('shopify:section:load', init);
 
  // A full section re-render replaces DOM nodes wholesale, so an observer
  // scoped to .cart__footer itself can get silently detached when that
  // element gets swapped out. Watch document.body instead so we keep
  // catching changes no matter what gets replaced.
  var observer = new MutationObserver(function () {
    moveWrapinBlock();
  });
  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
 
  // Run once immediately too, in case this script executes after
  // DOMContentLoaded has already fired (e.g. loaded dynamically).
  if (document.readyState !== 'loading') init();
})();
 


